import { isAbsoluteUrl } from "@client/lib/assets";
import classNames from "classnames";
import React from "react";
import { Link as RRDLink, type LinkProps as RRDLinkProps, type To } from "react-router-dom";

export type LinkProps = Omit<RRDLinkProps, "to"> & {
  isDisabled?: boolean;
  to?: To | null;
};

export default ({ isDisabled, reloadDocument, replace, state, to, ...props }: LinkProps) => {
  if (isDisabled) {
    return <a {...props} href="" onClick={(e) => e.preventDefault()} />;
  }

  if (to) {
    const url = typeof to === "string" ? to : to.pathname;
    if (url && !url.toLowerCase().startsWith("/admin") && !isAbsoluteUrl(url)) {
      return (
        <RRDLink
          {...props}
          reloadDocument={reloadDocument}
          replace={replace}
          state={state}
          to={to}
          suppressHydrationWarning
        />
      );
    }

    return <a {...props} href={url} />;
  }

  return <a {...props} className={classNames(props.className, { pointer: props.onClick })} />;
};
